<template>
  <div>
    <div id="force_reload_overlay" v-show="showContent">
      <div id="content">
        <p>
          当日受付の締切時刻である17時を過ぎたため、受取可能日時が更新されました。<br />
          お手数ですが以下のボタンをクリックしてページを更新してください。
        </p>
        <button @click="reloadPage" type="button" class="btn">
          ページを更新する<i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div class="step5" v-show="!readyCheckout">
      <p class="text-center step5__text1" @click="judgeDate">ご予約情報に間違いがないかお確かめ下さい。</p>
      <p class="borderBottom step5__infoTitle">受取日時</p>
      <p class="step5__dateInfo">
        <span class="span">{{ this.reservation.store.title.rendered }}</span
        >にて<span class="span"
          >{{ this.reservation.month }}月{{ this.reservation.date }}日({{ this.reservation.dayOfWeek }}){{
            this.reservation.time1
          }}:{{ this.reservation.time2 }}</span
        >ごろ
      </p>
      <div class="smartshop-container" v-show="selectedSmartshopEnabled">
        <div>
          <div class="robot-icon-container">
            <i class="robot-icon fa-solid fa-robot"></i>
          </div>
        </div>
        <div>
          <div class="smartshop-title">{{ this.reservation.store.title.rendered }}は”スマートショップ”です</div>
          <p class="smarthsop-description">
            スマートショップは、商品を専用のロッカーにてお受け取りいただける無人店舗です。確認メールに記載されたQRコードを専用ロッカーにかざすか伝票番号を入力することで受取が可能です。
          </p>
        </div>
      </div>
      <p class="borderBottom step5__infoTitle">商品情報</p>
      <div v-for="(itemCart, index) in reservation.cart" :key="index" class="step5--itemList">
        <p class="step5--itemListImg"><img v-bind:src="itemCart.image" class="step5--itemListImg--img" /></p>
        <div class="step5--itemListInfo">
          <p>{{ itemCart.name }}</p>
          <p v-if="checkCandle(index)">ローソク：大{{ itemCart.candle.big }}本　小{{ itemCart.candle.small }}本</p>
          <p v-if="itemCart.original == 'カットケーキ用メッセージカード'">
            メッセージプレートの内容<br />{{ itemCart.cut_cake_message }}
          </p>
          <p v-if="checkMsg(index)">メッセージカード：{{ itemCart.message }}</p>
          <p v-if="checkMsg2(index)">
            <span> <i class="second-message-icon fa-regular fa-square-check"></i>2枚目を希望する　+108円（税込） </span
            ><br />
            メッセージカード（2枚目）：{{ itemCart.message_2 }}
          </p>
          <p class="step5--itemListInfo_price">
            {{ itemCart.number }}個
            {{
              addMessage2Price(Number(itemCart.price), itemCart.number, itemCart.message_2_enabled)
                | calcTax(itemCart.name)
                | addComma
            }}円（税込）
          </p>
        </div>
        <p class="hiddenSum">
          {{ (Number(itemCart.price) + (itemCart.message_2_enabled ? 100 : 0)) * itemCart.number }}
        </p>
      </div>
      <div class="step5--itemListSum">
        <div class="step5--itemListSum__div">
          <p>小計{{ sumWithreducedTaxRate() | addComma }}円</p>
          <p class="ml-3">内税{{ calcWithreducedTaxRate() | addComma }}円</p>
        </div>
        <p class="borderBottom__sum step5--itemListSum__total">
          <span class="borderBottom_sum"
            >合計<span class="span_sum">{{ sumWithreducedTaxRate(reservation.sum) | addComma }}</span
            >円</span
          >
        </p>
      </div>
      <p class="borderBottom step5__infoTitle">お客様情報</p>
      <dl>
        <dt>氏名</dt>
        <dd>{{ this.reservation.customer.name1 }}</dd>
        <dt>フリガナ</dt>
        <dd>{{ this.reservation.customer.name2 }}</dd>
        <dt>電話番号</dt>
        <dd>{{ this.reservation.customer.tel }}</dd>
        <dt>メールアドレス</dt>
        <dd>{{ this.reservation.customer.email }}</dd>
        <dt>ご都合のつきやすい時間</dt>
        <dd>{{ this.reservation.customer.contactTime }}</dd>
        <dt>DM希望</dt>
        <dd>{{ this.reservation.customer.dm }}</dd>
        <dt>決済方法</dt>
        <dd>{{ this.reservation.customer.payment_method }}</dd>

        <dt class="dt_add">住所</dt>
        <dd class="dd_add">
          〒{{ this.reservation.customer.add1 }} {{ this.reservation.customer.add2 }}{{ this.reservation.customer.add3
          }}<br />{{ this.reservation.customer.add4 }}
        </dd>
        <dt>備考欄</dt>
        <dd>{{ this.reservation.customer.comment }}</dd>
      </dl>
      <p class="numberNotice text-danger">
        ※数が多いご注文の際はご希望にお応えできない場合がございますので、こちらからお電話させていただきます。連絡が取れない際には、キャンセルさせていただく場合がございます。ご了承くださいませ。
      </p>
      <p class="numberNotice text-danger">
        ※メール受信設定をされていないお客様へは、受注確認メールが届かない場合がございます。「web-order@g-spoon.co.jp」を受信許可設定された状態でご注文をお願い致します。
      </p>

      <button v-if="this.reservation.customer.payment_method === '店舗決済'" type="button" @click="next" class="btn">
        この内容で予約する<i class="fas fa-chevron-right"></i>
      </button>
      <button v-else type="button" @click="showCheckoutModal" class="btn">
        この内容で決済する<i class="fas fa-chevron-right"></i>
      </button>
      <p @click="prev(1)" class="a">
        <span><i class="fas fa-chevron-left"></i>お客様情報入力へもどる</span>
      </p>
    </div>
    <checkout
      :readyCheckout="readyCheckout"
      :reservation="reservation"
      @hideCheckoutModal="hideCheckoutModal"
      @createCheckoutUI="createCheckoutUI"
    ></checkout>
  </div>
</template>

<script>
import checkout from './checkout.vue'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

export default {
  name: 'step5',
  components: {
    checkout: checkout
  },
  data() {
    return {
      showContent: false
    }
  },
  props: [
    'dead_lines',
    'session_start_date',
    'buttonText',
    'step',
    'shops',
    'radioResult',
    'weeks',
    'calData',
    'reservation',
    'readyCheckout',
    'publishableKey',
    'reserveShops'
  ],
  computed: {
    selectedSmartshopEnabled: function() {
      return this.reserveShops.find(shop => shop.title.rendered === this.radioResult)?.acf?.smartshop
    }
  },
  filters: {
    addComma: function(val) {
      return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    calcTax: function(num, title) {
      // titleは商品名
      if (title && /ナンバーキャンドル/.test(title)) {
        return Math.trunc(Number(num) * 1.1)
      } else {
        return Math.trunc(Number(num) * 1.08)
      }
    }
  },
  methods: {
    reloadPage() {
      // ページをリロードする
      window.location.reload()
    },
    openModal: function() {
      this.showContent = true
    },
    closeModal: function() {
      this.showContent = false
    },
    sumWithreducedTaxRate: function() {
      //  税の合計を算出
      // カート内にあるナンバーキャンドルの合計金額を計算
      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      // 税の合計を計算
      return Math.trunc((this.reservation.sum - candleTotalPrice) * 1.08) + Math.trunc(candleTotalPrice * 1.1)
    },
    calcWithreducedTaxRate: function() {
      // 税込の総額を算出
      // カート内にあるナンバーキャンドルの合計金額を計算
      const candleTotalPrice = this.reservation.cart.reduce((acc, cur) => {
        if (cur.cat === 'ナンバーキャンドル') {
          return acc + Number(cur.number) * Number(cur.price)
        } else return acc
      }, 0)

      return Math.trunc((this.reservation.sum - candleTotalPrice) * 0.08) + Math.trunc(candleTotalPrice * 0.1)
    },
    addMessage2Price: function(price, count, enabled_message2) {
      return enabled_message2 ? Number(price) + 100 : price
    },
    judgeDate() {
      // 開始日から現在時間までの間に、配列の日付が存在するかチェック
      const current_time = dayjs()
      // const current_time = dayjs('2024-08-16 17:25')
      const hasDateInRange = this.dead_lines.some(time => {
        const hour = time.slice(0, 2) // 時間部分を取得
        const minute = time.slice(2) // 分部分を取得
        const dateToCheck = this.session_start_date
          .hour(parseInt(hour))
          .minute(parseInt(minute))
          .second(0)

        return dateToCheck.isBetween(this.session_start_date, current_time, null, '[]') // '[]'は開始日と終了日を含む
      })
      return hasDateInRange
    },
    showCheckoutModal: function() {
      if (this.judgeDate()) {
        this.showContent = true
        return
      }

      this.$emit('showCheckoutModal')
      this.$emit('createCheckoutUI')
      this.$emit('smoothScroll')
    },
    hideCheckoutModal() {
      this.$emit('hideCheckoutModal')
    },
    createCheckoutUI() {
      this.$emit('createCheckoutUI')
      this.$emit('smoothScroll')
    },
    next: function() {
      if (this.judgeDate()) {
        this.showContent = true
        return
      }

      this.$emit('next')
    },
    prev: function(number) {
      this.$emit('prev', number)
    },
    checkBox: function() {
      let checkBox = document.getElementsByName('checkBox')
      if (checkBox[0].checked) {
        this.reservation.flag1 = true
      } else {
        this.reservation.flag1 = false
      }
    },
    checkCandle: function(index) {
      if (
        this.reservation.cart[index].cat === 'ホールケーキ' ||
        this.reservation.cart[index].cat === '季節のイベントケーキ'
      ) {
        return true
      } else {
        return false
      }
    },
    checkMsg: function(index) {
      if (
        this.reservation.cart[index].cat === 'ホールケーキ' ||
        this.reservation.cart[index].cat === '季節のイベントケーキ'
      ) {
        return true
      } else {
        return false
      }
    },
    checkMsg2: function(index) {
      if (!this.reservation.cart[index].message_2) return false

      if (
        this.reservation.cart[index].cat === 'ホールケーキ' ||
        this.reservation.cart[index].cat === '季節のイベントケーキ'
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.step5 {
  padding: 0 15px;
  &__text1 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: center;
    color: #333333;
  }
  &__infoTitle {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    text-align: left;
    color: #333333;
  }
  &__dateInfo {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    text-align: center;
    color: #333333;
  }
  &--itemList {
    display: flex;
    border-bottom: 1px solid #ccc;
    margin-top: 15px;
    &Img {
      width: 20%;
      &--img {
        max-width: 100%;
      }
    }
    &Info {
      margin-left: 25px;
      width: 80%;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.64;
      text-align: left;
      color: #333333;
      p {
        @media (max-width: 767.98px) {
          margin-top: 0;
          margin-bottom: 5px;
        }
      }
      &_price {
        text-align: right;
      }
    }
    &Sum {
      margin-left: auto;
      &__div {
        display: flex;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.92;
        text-align: right;
        color: #333333;
        justify-content: flex-end;
      }
      &__total {
        font-size: 16px;
        line-height: 1.44;
        font-weight: bold;
        text-align: right;
        .borderBottom_sum {
          border-bottom: 2px #000 solid;
        }
        span {
          font-size: 21px;
          line-height: 1.1;
          margin-right: 0;
        }
      }
    }
    .hiddenSum {
      display: none;
    }
  }
}
.span {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.28;
  text-align: center;
  color: #333333;
}
.span_sum {
  font-weight: bold;
  margin-right: 15px;
  margin-left: 15px;
}
.borderBottom {
  border-bottom: 1px gray solid;
}
.a {
  color: #000;
  display: block;
  text-align: center;
  margin-top: 15px;
  i {
    margin-right: 5px;
  }
  span {
    border-bottom: 1px #000 solid;
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
}
.btn {
  text-align: center;
  display: block;
  margin: 30px auto 0;
  padding: 15px 0;
  background-color: #998018;
  color: #fff;
  width: 80%;
  font-size: 14px;
  font-weight: 500;
  line-height: 2;
  text-align: center;
  color: #ffffff;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  i {
    margin-left: 25px;
  }
}

dl {
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 767.98px) {
    display: block;
  }
  dt {
    height: 50px;
    width: 40%;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    color: #333333;
    @media (max-width: 767.98px) {
      width: 100%;
      height: 20px;
      margin-top: 10px;
    }
  }
  .dt_add {
    height: 60px;
    @media (max-width: 767.98px) {
      height: 25px;
    }
    span {
      font-size: 10px;
      line-height: 2.3;
    }
  }
  dd {
    height: 50px;
    width: 60%;
    margin: 0;
    text-align: left;
    @media (max-width: 767.98px) {
      width: 100%;
      height: 20px;
    }
  }
  .dd_add {
    height: 60px;
    @media (max-width: 767.98px) {
      height: 50px;
    }
  }
}

.smartshop-container {
  background-color: #f0f2fa;
  padding: 1.5rem;
  border-radius: 10px;
  margin-bottom: 2rem;
  display: flex;
  gap: 1.5rem;

  .robot-icon-container {
    width: 5rem;
    height: 5rem;
    background-color: #21446c;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    .robot-icon {
      font-size: 2.6rem;
      color: white;
    }
  }

  .smartshop-title {
    color: #21446c;
    font-weight: bold;
  }

  .smarthsop-description {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
}

.second-message-icon {
  margin-right: 0.5rem;
}

#force_reload_overlay {
  /*　要素を重ねた時の順番　*/
  z-index: 1;

  /*　画面全体を覆う設定　*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  /*　画面の中央に要素を表示させる設定　*/
  display: flex;
  align-items: center;
  justify-content: center;
}

#content {
  padding: 12px;
  z-index: 2;
  width: 50%;
  padding: 3em;
  border-radius: 8px;
  background: #fff;
}
</style>
